import { computed, inject, Injectable, Signal } from '@angular/core';
import { UserAddress } from '@lentau/address/shared/interfaces';
import { SetRequest } from 'angular-api-gateway/v1/model/setRequest';
import { REQUEST_STATE } from '@lentau/ui-kit/core/enums/request-state.enum';
import { Observable } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { isValidArrayData } from '@lentau/ui-kit/core/utils/array.utils';
import { DeliveryModeStore } from './delivery-mode.store';
import { Source20 } from 'analytic-events/Addresses/services/ChangeMethodService/events/Source20';

@Injectable({
  providedIn: 'root',
})
export class AddressesFacade {
  private store: DeliveryModeStore = inject(DeliveryModeStore);

  public list: Signal<UserAddress[]> = this.store.userAddresses;
  public list$: Observable<UserAddress[]> = toObservable(this.list);

  public requestState: Signal<REQUEST_STATE> = this.store.requestState;
  public requestState$: Observable<REQUEST_STATE> = toObservable(this.requestState);
  public isLoading: Signal<boolean> = computed(() => this.requestState() === REQUEST_STATE.LOADING);
  public isLoaded: Signal<boolean> = computed(() => this.requestState() === REQUEST_STATE.SUCCESS);

  public currentAddress: Signal<UserAddress> = computed(() =>
    isValidArrayData(this.list()) ? this.list().find((address: UserAddress) => address.Selected) : null
  );
  public currentAddress$: Observable<UserAddress> = toObservable(this.currentAddress);

  public totalCount: Signal<number> = computed(() => this.store.userAddresses().length);

  public dispatchReloadAfterAddressChange(): void {
    this.store.dispatchReloadAfterAddressChange();
  }

  public userAddressSearch(): void {
    this.store.userAddressSearch();
  }

  public userAddressAddByCode(data: UserAddress): void {
    this.store.userAddressAddByCode(data);
  }

  public userAddressAdd(data: UserAddress, eventSource?: Source20): void {
    this.store.userAddressAdd(data, eventSource);
  }

  public userAddressUpdate(data: UserAddress, shouldUpdateCart: boolean = true): void {
    this.store.userAddressUpdate(data, shouldUpdateCart);
  }

  public userAddressDelete(id: number): void {
    this.store.userAddressDelete(id);
  }

  public userAddressSet(data: SetRequest): void {
    this.store.userAddressSet(data);
  }

  public resetAll(): void {
    this.store.resetAll();
  }

  public setCache(address: UserAddress): void {
    this.store.setAddressCache(address);
  }
}
